<template>
  <div class="category-comp"  @mouseleave="mouseleave">
    <!-- <h3 class="title">All Category</h3> -->
    <div class="category-comp-box" :class="{ 'category-hover': hoverVisible }">
      <a :href="'/product-list/' + item.categoryUrl" v-for="(item, i) in categoryTree" :key="item.id" ref="category" :class="{ 'selected': i === selected}" class="category-item pointer f--c" @mouseenter="mouseenter(i)">
          <!-- <img :src="item.imgUrl"> -->
          <span class="category-name ellipsis text-hover">{{item.name}}</span>
          <i class="iconfont icon-Frame_2" style="color: #909399; width: 24px; height: 24px;" />
      </a>
    </div>
    <div v-show="hoverVisible" ref="categoryChild" class="category-popup f-b" :style="{visibility: activeIndex > -1 ? 'visible' : 'hidden' }">
      <div class="">
        <a :href="'/product-list/' + item2.categoryUrl" class="category-popup-item" v-for="item2 in categoryTree[activeIndex].childList" :key="item2.id">
          <h4 class="text-hover pointer">{{item2.name}}</h4>
          <p v-for="item3 in item2.childList" :key="item3.id" class="text-hover" :title="item3.name">
            <a style="color: inherit; text-decoration: none;" :href="'/product-list/' + item3.categoryUrl">
              {{item3.name}}
            </a>
          </p>
        </a>
        <div style="padding-bottom: 16px;"></div>
      </div>
      <!-- <div v-if="categoryTree && categoryTree.length && activeIndex>-1" class="category-img">
        <oss-img :src="categoryTree[activeIndex].imgUrl" :width="250" :height="250" />
      </div> -->
    </div>
  </div>
</template>

<script>
import OssImg from '../../../components/OssImg.vue'
export default {
  components: { OssImg },
  props: {
  },
  data() {
    return {
      activeIndex: 0,
      clientHeight: 680,
      hoverVisible: false,
      selected: null
    }
  },
  computed: {
    categoryTree() {
      return this.$store.state.common.categoryTree
    }
  },
  created() {
    if (this.categoryTree.length === 0) this.$store.dispatch('common/getCategoryTree')
  },
  mounted() {
    // this.getModuleHeight()
  },
  methods: {
    clickCategory({ categoryId, categoryUrl }) {
      // if (this.$route.fullPath.includes('/mall')) {
      //   this.$router.replace(`/product-list/${categoryUrl}`)
      // } else this.$router.push(`/product-list/${categoryUrl}`)
      location.href = `/product-list/${categoryUrl}`
      this.$emit('toProductList')
    },
    mouseenter(e) {
      this.activeIndex = e
      this.hoverVisible = true
      this.selected = e
    },
    getModuleHeight() {
      if (!this.$refs.categoryChild) {
        return
      }
      this.$nextTick(() => {
        this.clientHeight = this.$refs.categoryChild[this.activeIndex].clientHeight || this.clientHeight
        this.$emit('clientHeight', this.clientHeight)
      })
    },

    mouseleave() {
      this.hoverVisible = false
      this.selected = null
    }
  }
}
</script>

<style lang="scss" scoped>
.category-comp{
  position: relative;

  .category-comp-box {
    height: 376px;
    background: white;
    border-radius:  12px;
    overflow: hidden;
    padding: 8px 0;
  }
  .category-hover {
    // box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
    height: unset;
    min-height: 376px;
  }

  .title{
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 10px;
  }

  .category-item{
    margin-left: 12px;
    padding: 0 20px 0 8px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    position: relative;
    text-decoration: none;
    color: #606266;
    justify-content: space-between;
    height: 40px;
    img{
      width: 24px;
      height: 24px;
      border-radius: 100px;
      margin-right: 12px;
    }
  }
  .selected {
    background: #F5F7F7;
    color: #9AC331;
  }

  .category-popup{
    width: 792px;
    height: 376px;
    position: absolute;
    left: 246px;
    top: 0;
    background: #FFFFFF;
    box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.05), 0px 8px 10px 1px rgba(0,0,0,0.03), 0px 3px 14px 2px rgba(0,0,0,0.02);
    padding: 20px 0px 20px 24px;
    overflow-y: scroll;
    border-radius: 4px;
    z-index: 9;
    border: 1px solid rgba(0,0,0,0.15);

    .category-popup-item{
      color: inherit;
      text-decoration: none;
      display: block;
      margin-bottom: 20px;
    }
    h4{
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      padding-bottom: 4px;
      font-family: Poppins, Poppins;
    }
    p{
      width: 160px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #909399;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 28px;
    }

    .category-img{
      // position: absolute;
      flex-shrink: 0;
      right: 0;
      top: 30px;
      width: 250px;
      height: 250px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 0;
      }
    }
  }
  // .category-item:hover>.category-popup{
  //   visibility: visible;
  // }
  // .category-popup:hover{
  //   background: red;
  //   display: flex!important;
  // }

  // .category-img{
  //   position: absolute;
  //   right: 0;
  //   top: 30px;
  //   width: 250px;
  //   height: 250px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //   }
  // }
}
.text-hover:hover{
  cursor: pointer;
  color: #99C41C!important;
}
</style>
